import type React from 'react';
import { useTitle } from 'ahooks';
import { type ButtonProps, Grid, useMediaQuery } from '@mui/material';
import type { Flow } from '@/constants/flow';
import { useCustom } from '@/hooks/use-custom';
import { Banner } from './centered/banner';
import { FlowerBox } from './centered/flower-box';

interface StepBoxProps {
  title?: string | React.ReactNode;
  account?: string;
  children?: React.ReactNode;
  backFlow?: Flow;
  backButtonProps?: ButtonProps;
}

export const StepBox: React.FC<StepBoxProps> = ({ title, account, children, backFlow, backButtonProps }) => {
  const { layoutConfig } = useCustom();
  const isUpLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const showLogo = layoutConfig?.layout !== 'space-between';

  useTitle(typeof title === 'string' ? title : 'Lenovo ID', { restoreOnUnmount: true });

  return (
    <Grid container direction={layoutConfig?.centeredDirection || 'row'} rowGap={isUpLarge || showLogo ? 3 : 0}>
      <Banner backFlow={backFlow} />
      <FlowerBox
        account={account}
        children={children}
        backFlow={backFlow}
        title={title}
        backButtonProps={backButtonProps}
      />
    </Grid>
  );
};
